<script lang="ts" setup>
import type { RouteLocation } from "#vue-router";

const props = withDefaults(
  defineProps<{
    to?: RouteLocation | string;
    href?: string;
    loading?: boolean;
    disabled?: boolean;
    icon?: string;
    buttonClass?: string;
    iconClass?: string;
    accent?: boolean;
    circle?: boolean;
  }>(),
  {
    buttonClass: "",
    iconClass: "",
    accent: true,
    circle: false,
  },
);

const localePath = useLocalePath();

const classMap = computed(() =>
  Object.fromEntries(
    props.buttonClass
      .split(" ")
      .map((btClass) => [btClass.trim(), true])
      .concat([
        ["bt-accent", props.accent],
        ["bt-circle", props.circle],
        ["bt-icon", !!props.icon],
      ]),
  ),
);
</script>

<template>
  <a v-if="href" :href="href" :class="classMap">
    <div class="bt-content">
      <Icon v-if="icon" class="icon" :class="iconClass" :name="icon" />
      <slot />
    </div>
  </a>
  <NuxtLink v-else-if="props.to" :to="localePath(props.to)" :class="classMap">
    <div class="bt-content">
      <slot />
    </div>
  </NuxtLink>
  <button v-else :disabled="props.disabled" :class="classMap">
    <div class="bt-content h-full">
      <Icon
        v-if="props.loading"
        class="icon !cursor-wait"
        name="line-md:loading-loop"
      />
      <template v-else-if="icon">
        <Icon class="icon" :class="iconClass" :name="icon" />
        <slot />
      </template>
      <slot v-else />
    </div>
  </button>
</template>

<style lang="scss" scoped>
@import "~/assets/scss/_media";

button,
a {
  @apply px-4 py-3;
  @apply no-underline border-none outline-none;
  @apply text-sm text-center;
  @apply rounded-2xl;
  @apply transition-colors ease-in-out;

  @apply lg:text-base lg:px-8;

  .bt-content {
    @apply flex items-center justify-center gap-x-2;
    @apply lg:gap-x-3;
  }

  &.bt-accent {
    @apply bg-blue text-white font-bold hover:bg-blue-darker;
  }

  &.bt-circle {
    @apply rounded-full p-2;
  }

  &.dander {
    @apply bg-danger;
  }

  &.warning {
    @apply bg-warning;
  }

  &.success {
    @apply bg-success;
  }

  &.outline {
    @apply border border-solid border-blue bg-white text-blue;
    @apply hover:text-white hover:bg-blue;
  }

  .icon {
    @apply text-xl;
    @apply lg:text-3xl;
  }
}

//button,
//a {
//  background-color: var(--color-accent);
//  border: none;
//  outline: none;
//  border-radius: 15px;
//  color: #fff;
//  padding: 10px 50px;
//  transition: 0.25s background-color ease-in-out;
//
//  @include media("max", "md") {
//    padding-inline: 30px;
//  }
//
//  &:hover {
//    cursor: pointer;
//    background-color: var(--color-accent-darker);
//  }
//
//  &.outline {
//    border: 1px solid var(--color-accent);
//    color: var(--color-accent);
//    background: transparent;
//
//    &:hover {
//      background-color: var(--color-accent);
//      color: white;
//    }
//  }
//
//  &.outline-white {
//    border: 1px solid var(--color-light);
//    color: var(--color-light);
//    background: transparent;
//
//    &:hover {
//      background-color: var(--color-light);
//      color: var(--color-darker);
//    }
//  }
//
//  &.danger {
//    color: white;
//    background: var(--color-error);
//
//    &:hover {
//      background-color: var(--color-error-darker);
//      color: white;
//    }
//  }
//
//  &.success {
//    background-color: #059669;
//
//    &:hover {
//      background-color: #064e3b;
//    }
//  }
//  &.warning {
//    background-color: #ffcc49;
//    &:hover {
//      background-color: #c39c39;
//    }
//  }
//}
//
//button {
//  &:disabled {
//    background-color: #aeb8f1;
//    cursor: auto;
//  }
//}
</style>
